import { logRttApiCall } from './cabsAPIs';
import { API_STATUS } from './constants/errors';

export const logRttPhoneNumberErrorRequestBuilder = async (
  phoneNumber: string
) => {
  const request = {
    endPoint: '/v1/assistedFlow/formSubmit',
    rtt: 0,
    status: API_STATUS.FAILURE,
    httpStatus: 400,
    failureMessage: `Phone number validation failed for phone number: ${phoneNumber}`,
    error: 'PHONE_NUMBER_VALIDATION_FAILED'
  };

  await logRttApiCall(request);
};
